import React from 'react';

import AddEllipsisWithTooltip from '@components/common/EllipsisTooltip/AddEllipsisWithTooltip';
import { TextField } from '@components/detail-panel/components/EventStatusCard/styled';

import { MappedEventRowContainer, RelatedMappedEventTitle } from './styled';
import { IMappedEventRelatedCard } from './typed';

const MappedEventRelatedCard: React.FC<IMappedEventRelatedCard> = ({ dimension = {} }) => {
  const { mapped_event_names = [] } = dimension;
  return (
    <div>
      <RelatedMappedEventTitle>Mapped Event Names</RelatedMappedEventTitle>
      {mapped_event_names.map((name, index) => {
        return (
          <MappedEventRowContainer key={`${name}_${index}`}>
            <AddEllipsisWithTooltip text={name} dataIndex={'0'}>
              <TextField>{name}</TextField>
            </AddEllipsisWithTooltip>
          </MappedEventRowContainer>
        );
      })}
    </div>
  );
};

export default MappedEventRelatedCard;
